import { FC } from 'react';
import { TitleRow } from 'components/TitleRow';
import styles from './RefundList.module.scss';
import { UseInfiniteScrollHookRefCallback } from 'react-infinite-scroll-hook';
import { RefundType } from 'redux/Api/refundApi/type';
import { CustomerRefundItem } from 'ui/CustomerRefundItem';

interface TaxesListTypes {
  data: RefundType[];
  intersectionRef?: UseInfiniteScrollHookRefCallback;
}

export const RefundList: FC<TaxesListTypes> = ({ data, intersectionRef }) => {
  const dataTitle = [
    'ID',
    'Заказчик',
    'Получатель',
    'БИК',
    'Номер счета',
    'Сумма возврата, ₽',
    'Баланс',
    'Зарезервировано',
    'Одобрен',
    'Исполнен',
    'Дата создания',
  ];

  return (
    <div className={styles.root}>
      <TitleRow data={dataTitle} title={'refundsWorkSupport'} />
      {data ? (
        data.map((elem: RefundType, index: number) => {
          const triggerIndex = Math.max(0, data.length - 15);
          const shouldAttachRef = index === triggerIndex;

          return (
            <div key={elem.id} ref={shouldAttachRef ? intersectionRef : undefined}>
              <CustomerRefundItem refund={elem} />
            </div>
          );
        })
      ) : (
        <div className={styles.root_nothing}>
          <p>Ничего не найдено</p>
        </div>
      )}
    </div>
  );
};
